import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IExecutingAnalysisInfo } from './types';

type IExecutingAnalysis = Record<string, IExecutingAnalysisInfo>;
interface ISetExecutingAnalysisPayload extends IExecutingAnalysisInfo {
  analysisId: string;
}

const initialState: IExecutingAnalysis = {};

// Usually it takes time for Kobol to finish analysis execution.
// While execution is not finished, analysis will have status PENDING or RUNNING.
// This slice was introduced to store these analyses, because once status is
// SUCCESS or FAILED we show a toast message with optional redirect if user
// changed location.
// Once analysis is executed - we will remove it from slice
export default createSlice({
  name: 'executingAnalyses',
  initialState,
  reducers: {
    /**
     * setup info of analysis executing progress, and status.
     */
    setExecutingAnalysis: (
      draft,
      action: PayloadAction<ISetExecutingAnalysisPayload>,
    ) => {
      const { analysisId, executedAt, estimatedDuration } = action.payload;
      draft[analysisId] = {
        executedAt,
        estimatedDuration,
      };
    },

    /**
     * If analysis is complete - remove it
     */
    completeExecutingAnalysis: (
      draft,
      action: PayloadAction<{
        analysisId: string;
      }>,
    ) => {
      const { analysisId } = action.payload;
      if (draft[analysisId]) {
        delete draft[analysisId];
      }
    },
  },
});
